import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-admin-companypages',
    templateUrl: './admin-companypages.component.html',
    styleUrls: ['./admin-companypages.component.scss'],
    standalone: false
})
export class AdminCompanypagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
